import React, { useEffect } from 'react';
import { NextPage } from 'next';
import appLogo from '../assets/images/kecobo-logo.png';
import { withAnalytics, WithAnalyticsProps } from '../HOC/with-analytics';

const TOCPage: NextPage<WithAnalyticsProps> = (props) => {
  useEffect(() => {
    props.sendAnalytics('landingPage', 'Navigation');
  }, []);

  return (
    <div className="h-full bg-white lg:px-20 xl:px-64">
      <div className="w-full pt-4 md:pt-10 px-4 md:px-8 lg:px-0">
        <div className="w-24 sm:w-32 md:w-40">
          <img src={appLogo} alt="" />
        </div>
      </div>

      <div className="flex flex-col lg:flex-row mt-8 pb-12">
        <div className="w-full lg:w-9/12">
          <div className="px-4 md:px-8 lg:px-0">
            <p className="text-gray-900 text-2xl lg:text-3xl leading-none tracking-wide font-bold">
              Terms and conditions for the use of the Kenya Copyright Board (KECOBO) National Rights
              Registry
            </p>

            <h3 className="py-4 text-xl mt-4 font-bold">Use of the database information</h3>
            <ul>
              <li>
                <p>
                  The DATABASE and information obtained by National Rights Registry (NRR) platform
                  shall be used for record purposes.{' '}
                </p>
              </li>
              <li>
                <p>
                  There shall be no commercial use of any information or works without authority of
                  the owners of that information/works.
                </p>
              </li>
            </ul>

            <h3 className="py-4 mt-4 text-xl font-bold">Disclaimer</h3>
            <ul>
              <li>
                <p>
                  The information obtained from the database of the Registry save for organization
                  or formatting shall remain as provided by the user.
                </p>
              </li>
              <li>
                <p>
                  The administrator offers no warranty as to their accuracy or truthfulness
                  including express or implied ownership or authorship of the work.
                </p>
              </li>
            </ul>

            <h3 className="py-4 mt-4 text-xl font-bold">Liability</h3>
            <p>
              The database owner/administrator shall not be liable for any loss, damage or costs
              resulting from reliance on the information on this database without due diligence
            </p>

            <h3 className="py-4 mt-4 text-xl font-bold">Use of personal data</h3>
            <p>
              The database owner/administrator shall not be liable for any loss, damage or costs
              resulting from reliance on the information on this database without due diligence
            </p>
            <ul>
              <li>
                <p>
                  Personal Data collected on the database/Platform shall not be made visible or
                  available or provided to third parties or users except an extract of
                </p>
                <ul>
                  <li>
                    <p>Authors name(s)</p>
                  </li>
                  <li>
                    <p>Author work(s)</p>
                  </li>
                  <li>
                    <p>
                      Date of release/production/completion of the work as uploaded by the user.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  No personal data except as indicated above shall be available for sharing or sale
                  unless there is a written authorization of the affected persons.
                </p>
              </li>
            </ul>

            <h3 className="py-4 mt-4 text-xl font-bold">Security</h3>
            <p>
              The administrator/owner undertakes to employ multilevel technologies to protect
              personal data shared with the database.
            </p>

            <h3 className="py-4 mt-4 text-xl font-bold">Term of retention of data</h3>
            <p>
              The data shall be kept as long as the NRR exists as a function of the Kenya Copyright
              Board (KECOBO) or its successor agency.
            </p>

            <h3 className="py-4 mt-4 text-xl font-bold">Changes</h3>
            <p>
              Any changes to this policy shall be posted on the KECOBO website before it is effected
              and communicated on emails provided on registration to enable users consider their
              positions.
            </p>
          </div>
        </div>
      </div>

      <style jsx>{`
        ul {
          list-style: square;
          padding-left: 2rem;
          // list-style-type: dot;
        }

        ul ul {
          list-style-type: lower-alpha;
        }
      `}</style>
    </div>
  );
};

export default withAnalytics(TOCPage);
